import { PipelineConfigSummary } from '@optools/services/operator-gateway/pipeline-config/types';
import { Region } from '@optools/services/operator-gateway/types/generated/graphql';

export interface PipelineConfigRegion {
  id: number | null;
  region: Region;
}

export interface GroupedPipelineConfig {
  regions: PipelineConfigRegion[];
  teamId: number;
}

// EAST first since it is the default region shown in the config sheet.
const REGION_ORDER: Region[] = [Region.EAST, Region.CENTRAL];

/**
 * Groups region-scoped pipeline config summaries into one entry per team, always
 * including a row for every region so teams without a config for a region still surface it.
 */
export function groupPipelineConfigsByTeam(
  summaries: PipelineConfigSummary[],
): GroupedPipelineConfig[] {
  const teamRegions = new Map<number, Map<Region, number>>();

  for (const { id, region, teamId } of summaries) {
    if (teamId == null || region == null) continue;

    const regions = teamRegions.get(teamId) ?? new Map<Region, number>();
    regions.set(region, id);
    teamRegions.set(teamId, regions);
  }

  return [...teamRegions.entries()].map(([teamId, regions]) => ({
    regions: REGION_ORDER.map((region) => ({
      id: regions.get(region) ?? null,
      region,
    })),
    teamId,
  }));
}
